import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminOrganizationUsersListPage = () => {
  return (
    <>
      <Helmet>
        <title>Organization Users list - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
